module.exports = __webpack_public_path__ + "img/p2-45.2c787d5c.png";